import { TitleBlockWrapper, TitleDescription } from '@anm/components/TitleBlock';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const pricingTableWrapperResponsive = media.tablet`
    flex-direction: column;
    align-items: center;
`;

export const PricingTableWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 1140px;
  margin: 0 auto 77px;
  ${pricingTableWrapperResponsive};
`;

const wrapperResponsive = media.desktop_small`
    padding: 0 30px 40px 18px;
`;

const wrapperTablet = media.tablet`
    padding: 34px 40px 40px 40px;
    width: 280px;
    border: 0 none;
    border-bottom: 1px solid #EBEEF5;
    flex-basis: auto;
`;

const mediumMobile = media.phone`
    margin-bottom: 20px;
`;

export const Top = styled.div``;
export const Medium = styled.div`
  display: flex;

  ${mediumMobile};
`;
export const Bottom = styled.div`
  margin-top: auto;
  ${TitleBlockWrapper} {
    margin-bottom: 12px;
    ${TitleDescription} {
      color: inherit;
    }
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 0;
  flex-grow: 1;
  padding: 0 20px 35px;
  position: relative;
  &:last-of-type {
    border-right: 0 none;
  }
  ${wrapperResponsive};
  ${wrapperTablet};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;
